import React, { useContext } from 'react'

import { SELECT_ROOM } from '../../Constants'
import { PAXContext } from './PaxContext'
import { PaxTab } from './PaxTab'

/**
 * Pax Room Component Render
 * This is the wrapper for tab component
 */
function PaxRoom({ color }) {
	const [{ activeRoom = 0, roomsCount = 1 }, dispatch] = useContext(PAXContext)
	return (
		<PaxTab
			roomsCount={roomsCount}
			activeIndex={activeRoom - 1}
			onClickAction={value => {
				dispatch({
					type: SELECT_ROOM,
					payload: { activeRoom: value + 1 },
				})
			}}
			color={color}
		/>
	)
}

export default PaxRoom
